import { TableParams } from '../types';

export const usersTypes = {
  GET_USERS: 'GET_USERS',
  GET_USER_BY_ID: 'GET_USER_BY_ID',
  GET_CURRENT_PROFILE: 'GET_CURRENT_PROFILE',
  GET_AUTHENTICATED_USER: 'GET_AUTHENTICATED_USER',
  SET_AUTHENTICATED_USER: 'SET_AUTHENTICATED_USER',
  CREATE_USER: 'CREATE_USER',
  UPDATE_USER: 'UPDATE_USER',
  DELETE_USER: 'DELETE_USER',
};

export type IUsersState = Readonly<{
  users: Array<any>;
}>;

export type CreateUserPayload = {
  firstName: string;
  lastName: string;
  email: string;
  mobile: string;
  role: string;
  companyOrLawFirm: string;
};

export type UpdateUserPayload = {
  id: string;
  body: CreateUserPayload;
};

export type GetUserDetailParam = { id: string };

export type GetUsersParams = TableParams & { [key: string]: string };
